import clsx from 'clsx';
import React from 'react';

import ProExclusiveLogo from '@components/ProExclusiveLogo';
import { TI502026Props } from '@interfaces/ti50';
import { article_path } from '@routes';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

type HeaderProps = Pick<TI502026Props, 'isSEOBot' | 'project' | 'tier'>;

const Header = ({ isSEOBot, project, tier }: HeaderProps) => (
  <div id="header-section" className="px-12">
    <div className="mx-auto w-full max-w-full sm:w-3/4">
      {project.isPro && <ProExclusiveLogo />}
      <h1 className="flex flex-col items-center text-center font-suisse-screen">
        <span className="font-suisse-works text-headline-xxs xs:text-headline-sm md:text-headline-lg">
          The Information&rsquo;s
        </span>
        <span className="text-headline-sm xs:text-headline-alt-md md:text-headline-alt-lg">
          50 Most Promising Startups
        </span>
        <span className="max-w-fit border-0 border-y-[1px] border-solid border-primary-magenta text-headline-xxs leading-[170%] xs:text-headline-sm md:text-headline-lg">
          2026
        </span>
      </h1>
      <h2 className="sr-only">{project.title}</h2>
      <div className="mx-auto w-4/5">
        {tier === 'pro' || isSEOBot ? (
          <div
            className={clsx('mt-48 text-body-md xs:text-body-lg', {
              'seo-paywall-content': isSEOBot,
            })}
            id="ti50-2026-description"
            data-nosnippet
          >
            {AuthoredContentReactToHtmlParser(project.description)}
          </div>
        ) : (
          <p className="mt-48 text-body-md xs:text-body-lg" id="ti50-2026-description">
            Companies with the potential to be the most valuable businesses in their
            categories—based on current revenues, business models, and growth prospects.
          </p>
        )}
        {project.article?.publishedAt && (
          <p className="mt-32 text-body-md xs:text-body-lg">
            Read{' '}
            <a
              className="font-bold underline hover:text-primary-magenta dark:hover:text-primary-pink"
              href={article_path(project.article.slug)}
            >
              {project.article.title}
            </a>
          </p>
        )}
      </div>
    </div>
  </div>
);

export default Header;
